import { useSelector } from 'react-redux';
import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { useScreenResolution } from '@app/hooks';
import { selectUserInfo } from '@app/redux';

import Park from '../img/Park';

import styles from './styles.module.scss';

const ProfileHeader = (): JSX.Element => {
  const { t } = useTranslation('Profile');
  const {
    userInfo: { accountNumber },
    loading,
  } = useSelector(selectUserInfo);
  const { isMedium, isLarge, isExtraLarge } = useScreenResolution();
  const isDesktop = isMedium || isLarge || isExtraLarge;

  return (
    <div data-cy="profile-header" className={styles['profileHeader']}>
      <div className={styles['headerTextContainer']}>
        <Txt variant="heading3" component="span">
          {t('accountSettings')}
        </Txt>
        {loading ? (
          <div className={styles['loadingContainer']}>
            <Txt variant="bodyLargeRegular" component="span">
              {t('accountNumberLoading')}
            </Txt>
            <div className={styles['loading']} />
          </div>
        ) : (
          <Txt variant="bodyLargeRegular" component="span">
            {t('accountNumber', { account_number: accountNumber })}
          </Txt>
        )}
      </div>
      {isDesktop && <Park />}
    </div>
  );
};

export default ProfileHeader;
